import { render, staticRenderFns } from "./RegularOrderDetail.vue?vue&type=template&id=ae11a4ee&scoped=true&"
import script from "./RegularOrderDetail.vue?vue&type=script&lang=js&"
export * from "./RegularOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./RegularOrderDetail.vue?vue&type=style&index=0&id=ae11a4ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae11a4ee",
  null
  
)

export default component.exports